import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged } from "rxjs";
import { CorpPayor } from "src/app/common/interfaces/corp-payor.interface";

@Injectable()
export class PayorStore {
  private _payor$ = new BehaviorSubject<CorpPayor | null>(null);
  payor$ = this._payor$.pipe(distinctUntilChanged());

  setpayor(payor: CorpPayor) {
    this._payor$.next(payor);
  }
}
